import {
  FETCH_COLLABORATOR_INFO,
  SEND_COLLABORATOR,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_COLLABORATOR,
  FETCHED_COLLABORATOR,
  SUBMITED_COLABORADOR,
  SUBMIT_COLABORADOR_ERROR,
  RESET_COLABORADOR_SUBMIT,
  CLEAR_ALERT_DIALOG,
  RESET_COLABORADOR_PROCESSING,
  STARTED_COLABORADOR_PROCESSING,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_colaboradores: false,
  submited_colaborador: false,
  processing_colaborador: false,
  loading_collaborator: false,
};

const getters = {
  is_loading() {
    return state.loading_colaboradores;
  },
  colaborador_submited() {
    return state.submited_colaborador;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  colaborador_processing() {
    return state.processing_colaborador;
  },
};

const actions = {
  [FETCH_COLLABORATOR_INFO](context, collaboratorId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_COLLABORATOR);
      const url = `censos/colaborador/${collaboratorId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(FETCHED_COLLABORATOR);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_COLLABORATOR);
        });
    });
  },
  [SEND_COLLABORATOR](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.upload('censos/colaborador', data)
        .then(({ data }) => {
          context.commit(SUBMITED_COLABORADOR, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_COLABORADOR_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [FETCHING_COLLABORATOR](state) {
    state.loading_collaborator = true;
  },
  [FETCHED_COLLABORATOR](state) {
    state.loading_collaborator = false;
  },
  [SUBMITED_COLABORADOR](state, data) {
    state.submited_colaborador = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [SUBMIT_COLABORADOR_ERROR](state, data) {
    state.processing_colaborador = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_COLABORADOR_SUBMIT](state) {
    state.submited_colaborador = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
  [RESET_COLABORADOR_PROCESSING](state) {
    state.processing_colaborador = false;
  },
  [STARTED_COLABORADOR_PROCESSING](state) {
    state.processing_colaborador = true;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
